// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './Hint.less';

/**
 * `Hint` component.
 */
const Hint = ({ baseClassName, className, children, ...props }) => (
    <span className={classNames(baseClassName, className)} {...props}>
        {children}
    </span>
);

Hint.propTypes = {
    /**
     * Content of the `Hint`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Hint.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}hint`,
};

export default Hint;



// WEBPACK FOOTER //
// ./components/Hint/Hint.js